import axios from 'axios'
import { Buffer } from "buffer";
import pako from 'pako'
import XXH from 'xxhashjs'

const pb = require('./kumaproto').kuma.jp.protobuf.web
const pbc = require('./kumaproto').kuma.jp.protobuf.common
const XXH32_SEED = 0xffffffff

const parsers = new Map([
  [pb.PlayerCampPitInfoResp.CommandNo.COMMAND_NO, pb.PlayerCampPitInfoResp.decode],
  [pb.AlbumPuriContentUpdateResp.CommandNo.COMMAND_NO, pb.AlbumPuriContentUpdateResp.decode],
  [pb.AlbumPuriListResp.CommandNo.COMMAND_NO, pb.AlbumPuriListResp.decode],
  [pb.CouponListResp.CommandNo.COMMAND_NO, pb.CouponListResp.decode],
  [pb.CouponResp.CommandNo.COMMAND_NO, pb.CouponResp.decode],
  [pb.CouponHistoryResp.CommandNo.COMMAND_NO, pb.CouponHistoryResp.decode],
  [pb.BannerListResp.CommandNo.COMMAND_NO, pb.BannerListResp.decode],
  [pb.BuyCardUpdateResp.CommandNo.COMMAND_NO, pb.BuyCardUpdateResp.decode],
  [pb.BuyMembershipUnsubscribeResp.CommandNo.COMMAND_NO, pb.BuyMembershipUnsubscribeResp.decode],
  [pb.BuyMembershipResultResp.CommandNo.COMMAND_NO, pb.BuyMembershipResultResp.decode],
  [pb.BuyMembershipStartResp.CommandNo.COMMAND_NO, pb.BuyMembershipStartResp.decode],
  [pb.BuyMembershipUpdateResp.CommandNo.COMMAND_NO, pb.BuyMembershipUpdateResp.decode],
  [pb.MailAddressRegistrationResp.CommandNo.COMMAND_NO, pb.MailAddressRegistrationResp.decode],
  [pb.NewsListResp.CommandNo.COMMAND_NO, pb.NewsListResp.decode],
  [pb.PlayerInfoResp.CommandNo.COMMAND_NO, pb.PlayerInfoResp.decode],
  [pb.PlayerUnsubscribeResp.CommandNo.COMMAND_NO, pb.PlayerUnsubscribeResp.decode],
  [pb.PlayerUpdateInfoResp.CommandNo.COMMAND_NO, pb.PlayerUpdateInfoResp.decode],
  [pb.PlayerRegistrationResp.CommandNo.COMMAND_NO, pb.PlayerRegistrationResp.decode],
  [pb.PlayerResetPassMailResp.CommandNo.COMMAND_NO, pb.PlayerResetPassMailResp.decode],
  [pb.PlayerResetPassResp.CommandNo.COMMAND_NO, pb.PlayerResetPassResp.decode],
  [pb.PlayerDigitalPassResp.CommandNo.COMMAND_NO, pb.PlayerDigitalPassResp.decode],
  [pb.PuriContentListResp.CommandNo.COMMAND_NO, pb.PuriContentListResp.decode],
  [pb.PuriContentResp.CommandNo.COMMAND_NO, pb.PuriContentResp.decode],
  [pb.SheetAddResp.CommandNo.COMMAND_NO, pb.SheetAddResp.decode],
  [pb.SheetListResp.CommandNo.COMMAND_NO, pb.SheetListResp.decode],
  [pb.LoginResp.CommandNo.COMMAND_NO, pb.LoginResp.decode],
  [pb.LogoutResp.CommandNo.COMMAND_NO, pb.LogoutResp.decode],
  [pb.PlayerTwitterTokenResp.CommandNo.COMMAND_NO, pb.PlayerTwitterTokenResp.decode],
  [pb.TutorialListResp.CommandNo.COMMAND_NO, pb.TutorialListResp.decode],
  [pb.PlayerTutorialShowResp.CommandNo.COMMAND_NO, pb.PlayerTutorialShowResp.decode],
  [pb.PlayerTutorialListResp.CommandNo.COMMAND_NO, pb.PlayerTutorialListResp.decode],
  [pb.NewsResp.CommandNo.COMMAND_NO, pb.NewsResp.decode],
  [pb.PlayerLineTokenResp.CommandNo.COMMAND_NO, pb.PlayerLineTokenResp.decode],
  [pbc.Maintenance.CommandNo.COMMAND_NO, pbc.Maintenance.decode],
  [pb.PlayerValidateKeyCheckResp.CommandNo.COMMAND_NO, pb.PlayerValidateKeyCheckResp.decode],
  [pb.PlayerUpdateMailAddressResp.CommandNo.COMMAND_NO, pb.PlayerUpdateMailAddressResp.decode],
  [pb.CampaignFriendItemGetResp.CommandNo.COMMAND_NO, pb.CampaignFriendItemGetResp.decode],
  [pb.CampaignFriendPointResp.CommandNo.COMMAND_NO, pb.CampaignFriendPointResp.decode],
  [pb.CampaignFriendHistoryResp.CommandNo.COMMAND_NO, pb.CampaignFriendHistoryResp.decode],
  [pb.BonusResp.CommandNo.COMMAND_NO, pb.BonusResp.decode],
  [pb.BuyMembershipListResp.CommandNo.COMMAND_NO, pb.BuyMembershipListResp.decode],
  [pb.AnnounceResp.CommandNo.COMMAND_NO, pb.AnnounceResp.decode],
  [pb.CouponSettingResp.CommandNo.COMMAND_NO, pb.CouponSettingResp.decode],
  [pb.KumaMasterSettingResp.CommandNo.COMMAND_NO, pb.KumaMasterSettingResp.decode],
  [pb.PlayerGeneralInformationResp.CommandNo.COMMAND_NO, pb.PlayerGeneralInformationResp.decode],
  [pbc.KumaError.CommandNo.COMMAND_NO, pbc.KumaError.decode]
])

export function post(seqNo, token, cmdNo, pbpln) {
  const tokenLen = token.length
  const headerLen = tokenLen + 4 + 4 + 4 + 4
  
  const pbcmp = pako.deflate(pbpln, {level:9, raw: true})
  let content, plen
  if (pbcmp.length < pbpln.length) {
    plen = pbpln.length
    content = Buffer.from(pbcmp)
  } else {
    plen = 0
    content = Buffer.from(pbpln)
  }
  
  let hash = XXH.h32(content.buffer, XXH32_SEED).toNumber()
  let buf = Buffer.alloc(headerLen + content.length)
  Buffer.from(token).copy(buf)
  let pos = tokenLen
  buf.writeInt32LE(seqNo, pos)
  pos += 4
  buf.writeInt32LE(cmdNo, pos)
  pos += 4
  buf.writeInt32LE(plen, pos)
  pos += 4
  buf.writeUInt32LE(hash, pos)
  if (content.length > 0) {
    Buffer.from(content).copy(buf, headerLen)
  }
  
  const config = {
    headers: {
      'Content-Type': 'application/octet-stream',
    },
    responseType: 'arraybuffer'
  }

  let url = process.env.VUE_APP_API_SERVER_URL
  if (process.env.NODE_ENV === "development") {
      url = url.replace(/.*:\/\/[^/]+/, "")
  }

  return new Promise((resolve, reject) => {
    axios.post(url, buf.buffer, config)
      .then( result => {
        buf = Buffer.from(result.data)
        buf.copy(token)
        pos = tokenLen
      
        if (seqNo !== buf.readInt32LE(pos)) {
          const msg = 'seqNo: ' + seqNo + ', bad sequence number'
          const err = new Error(msg)
          reject(err)
          return
        }
      
        pos += 4
        cmdNo = buf.readInt32LE(pos)
        pos += 4
        plen = buf.readInt32LE(pos)
        pos += 4
        hash = buf.readUInt32LE(pos)
      
        let pbpln2 = Buffer.from(buf.subarray(headerLen))
        if (hash !== XXH.h32(pbpln2.buffer, XXH32_SEED).toNumber()) {
          const msg = 'seqNo: ' + seqNo + ', bad hash'
          const err = new Error(msg)
          reject(err)
          return
        }
      
        if (plen > 0) {
          let pbcmp2 = pako.inflate(pbpln2, {raw: true})
          pbpln2 = pbcmp2
        }
      
        let parser = parsers.get(cmdNo)
        if (parser === undefined) {
          const err = new Error("parser not found")
          reject(err)
          return
        }
      
        const decoded = parser(pbpln2)

        if(decoded.isMaintenanceNow && (!decoded.maintenanceInfo || !decoded.maintenanceTitle )){
          const err = new Error("maintenance info not found")
          reject(err)
        }
        if (cmdNo === pbc.Maintenance.CommandNo.COMMAND_NO || cmdNo === pbc.KumaError.CommandNo.COMMAND_NO) {
          reject(decoded)
        } else {
          resolve(decoded)
        }
      })
      .catch(err => {
        reject(err)
      })
    
  })
}
